export default __webpack_public_path__ + "static/media/uv0_kr_alph_a2.6fb34aad.mp3";